import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { resetBlock } from './EnergyReplaceBlockSlice';
import { prepareBlockAsync } from './EnergyReplaceBlockAsyncThunk';
import ProgressBar from '../../Shared/ProgressBar/progressBar';
import BackButton from './Partials/BackButton/BackButton';
//pages
import SubscribersPage from './Pages/SubscribersPage/SubscribersPage';
import PackagesPage from './Pages/PackagesPage/PackagesPage';
import SendAgreementPage from './Pages/SendAgreementPage/SendAgreementPage';
import ErrorPage from './Pages/ErrorPage/ErrorPage';
import SuccessPage from './Pages/SuccessPage/SuccessPage';

const EnergyReplace = (props) => {
    let currentView = null;

    useEffect(() => {
        props.prepareBlockAsync({ energyReplaceBlock: props.iContent });
        return () => {
            props.resetBlock();
        }
    }, []);

    const handleOnLinkClick = () => {
      window.history.back();
    };

    switch (props.page) {
        case 'subscribersPage': currentView = <SubscribersPage />; break;
        case 'packagesPage': currentView = <PackagesPage />; break;
        case 'sendAgreementPage': currentView = <SendAgreementPage />; break;
        case 'errorPage': currentView = <ErrorPage />; break;
        case 'successPage': currentView = <SuccessPage />; break;
    }

      return (
        <div className='energy-replace-block-wrapper'>
          {props.page !== 'errorPage' && <ProgressBar points={props.progressBarPoints} percent={props.pagePercent} />}
          <BackButton />
          {currentView}
        </div>
      );
};

const mapStateToProps = (state) => {
    return {
        page: state.energyReplaceBlock.page,
        pagePercent: state.energyReplaceBlock.pagePercent,
        progressBarPoints: state.energyReplaceBlock.progressBarPoints,
    };
};

const mapDispatchToProps = { prepareBlockAsync, resetBlock };

export default connect(mapStateToProps, mapDispatchToProps)(EnergyReplace);
